"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewport = exports.initialState = void 0;
exports.isMobile = isMobile;
var mobile = require("@caddigital/sok-ui/lib/utils/mobile");
var ActionTypes = require("../actionTypes/viewport");
exports.initialState = {
    size: 'DESKTOP'
};
var viewport = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case ActionTypes.SET_SIZE:
            return __assign(__assign({}, state), { size: action.payload });
        default:
            return state;
    }
};
exports.viewport = viewport;
function isMobile(state) {
    return state.size !== 'DESKTOP' || mobile.isMobile || mobile.isMobileSafari; // SEE sok-ui/assets/sass/_variables.scss
}
